import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { DocumentFormTypes } from "models/formTypes";
import { SupplementaryMaterialTodoSelectionFormContainerProps } from "models/propTypes/supplementaryMaterialPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useSupplementaryMaterialService } from "serviceHooks";
import SupplementaryMaterialTodoSelectionForm from "./todoSelectionForm";
//#endregion
import * as Yup from "yup";

const SupplementaryMaterialTodoSelectionFormContainer: ForwardRefRenderFunction<
  FormHandles,
  SupplementaryMaterialTodoSelectionFormContainerProps
> = (props, ref) => {
  const supplementaryMaterialService = useSupplementaryMaterialService();
  const { supplementaryMaterial } = props;

  const initialValues = {
    comment: "",
    files: [],
  };

  const validationSchema = React.useMemo(
    () =>
      Yup.object<DocumentFormTypes.SupplementaryMaterial>({
        comment: Yup.string().required(TranslationKeys.Validations.Required),
        files: Yup.array().of(
          Yup.object<UploadedFile>({
            contentType: Yup.string(),
            fileName: Yup.string(),
            fileSize: Yup.number(),
            data: Yup.string(),
          })
        ),
      }),
    []
  );

  const submitSupplementaryMaterial = (values: DocumentFormTypes.SupplementaryMaterial) => {
    const files = values.files as ApiModel.SupplementaryMaterialAttachment[];
    return supplementaryMaterialService.submitSupplementaryMaterial(supplementaryMaterial.id, values.comment, files);
  };

  return (
    <SupplementaryMaterialTodoSelectionForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={submitSupplementaryMaterial}
    />
  );
};

export default forwardRef(SupplementaryMaterialTodoSelectionFormContainer);
